module.exports = __webpack_public_path__ + "img/kv_sp_01.6ed495de.jpg";